module.exports = __webpack_public_path__ + "media/amp_version/fastweb-logo-a-monster-company-9e19fb15.svg";